import styled, { css } from "styled-components";
import MainTabs from "ui/common/components/navigation/MainTabs/MainTabs";

export const YellowTabsRoot = styled(MainTabs)(
    ({ theme }) => css`
        .TabsTab {
            color: ${theme.palette.primary} !important;
            background-color: ${theme.palette.secondary} !important;
            border-radius: 25px;
            padding: 0.5rem 0px !important;
            font-size: 9.5px !important;
        }

        .TabsTab.Active {
            background-color: ${theme.palette.primary} !important;
            color: white !important;
        }

        .TabGroupContainer {
            gap: 8px !important;
            padding: 0px !important;
            border: none !important;
        }

        .TabGroup button {
            display: none;
        }

        .TabIndicator {
            background-color: transparent !important;
        }
    `,
);
